export const boxShadowClass = 'shadow-xs';
